<header class="header" [class.scrolled]="isScrolled">
  <div class="header-main">
    <div>
      <span class="logo-label clickable-logo" (click)="onLogoClick()">
        <img src="../../assets/logo.png" alt="Evaltrix Logo">
        <span
          *ngIf="loginSuccess && (paymentStatus === 'Free Trial Expired' || paymentStatus === 'Free Trial')">{{paymentStatus}}</span>
      </span>
    </div>

    <!-- Mobile CTA - visible only on mobile/tablet -->
    <a class="mobile-cta" [routerLink]="['/login/employerLogin']" [queryParams]="{signupView: true}"
      *ngIf="!loginSuccess">Try Free</a>

    <button mat-icon-button [matMenuTriggerFor]="hmenu" class="menu-icon" aria-label="Menu">
      <mat-icon>menu</mat-icon>
    </button>
    <mat-menu #hmenu="matMenu">
      <button mat-menu-item [matMenuTriggerFor]="product">Products</button>
      <button mat-menu-item>
        <a class="button button-text button-text-dark header-secondary-button" href="https://help.evaltrix.com/product"
          target="_blank" rel="noopener noreferrer" [routerLinkActive]="['active-item']">Help</a>
      </button>
      <button mat-menu-item routerLink="pricing" [routerLinkActive]="['active-item']"> Pricing </button>
      <button mat-menu-item (click)="getStarted()"> Get started </button>

      <button mat-menu-item routerLink="login" [routerLinkActive]="['active-item']"> Login </button>
    </mat-menu>
    <mat-menu #product="matMenu">
      <button mat-menu-item routerLink="productFeatures" [routerLinkActive]="['active-item']">Product Features</button>
      <button mat-menu-item routerLink="aboutProduct" [routerLinkActive]="['active-item']">About</button>
    </mat-menu>

    <div class="header-links">
      <ng-container *ngIf="!loginSuccess">
        <div class="header-right-items">
          <a class="try-cta" [routerLink]="['/login/employerLogin']" [queryParams]="{signupView: true}">Try for free</a>
          <a class="demo-cta" [routerLink]="['/demo']">Get a free demo</a>
          <button mat-button [matMenuTriggerFor]="product"
            class="button button-text button-text-dark header-secondary-button">Products
            <mat-icon class="mat-icon material-icons" role="img" aria-hidden="true">arrow_drop_down</mat-icon>
          </button>
          <mat-menu #product="matMenu">
            <button mat-menu-item routerLink="productFeatures" [routerLinkActive]="['active-item']">Product
              Features</button>
            <button mat-menu-item routerLink="aboutProduct" [routerLinkActive]="['active-item']">About</button>
          </mat-menu>
          <a class="button button-text button-text-dark header-secondary-button"
            href="https://help.evaltrix.com/product" target="_blank" rel="noopener noreferrer"
            [routerLinkActive]="['active-item']">Help</a>
          <a class="button button-text button-text-dark header-secondary-button" [routerLink]="['/pricing']"
            [routerLinkActive]="['active-item']">Pricing</a>
          <a class="button button-text button-text-dark header-secondary-button" [routerLink]="['/login']"
            [routerLinkActive]="['active-item']">Login</a>
        </div>
      </ng-container>
      <ng-container *ngIf="loginSuccess">
        <div>
          <a class="button-text header-secondary-button dashoard" routerLink="/dashboard/home"
            [routerLinkActive]="['active-item']">Home</a>
          <a class="button-text header-secondary-button dashoard" routerLink="/dashboard/assessments"
            [routerLinkActive]="['active-item']">Assessments</a>
          <a class="button-text header-secondary-button dashoard" routerLink="/dashboard/questions"
            [routerLinkActive]="['active-item']">Questions</a>

          <a class="button-text header-secondary-button dashoard" routerLink="/dashboard/settings"
            [routerLinkActive]="['active-item']" *ngIf="role==='ENTERPRISE_ADMIN'">Settings</a>

          <a class="button-text header-secondary-button dashoard disabled-btn"
            *ngIf="role !=='ENTERPRISE_ADMIN'">Settings</a>

          <a class="button-text header-secondary-button dashoard" routerLink="/dashboard/pricing"
            [routerLinkActive]="['active-item']" *ngIf="shouldShowPricingLink()">Pricing</a>
        </div>

        <div>

          <a *ngIf="showSubscriptionBadge()" class="sub-status-badge" [ngClass]="getStatusClass(paymentStatus)"
            [routerLink]="['/dashboard/pricing']" [routerLinkActive]="['active-item']" matTooltip="Manage subscription">
            {{ getStatusLabel(paymentStatus) }}
          </a>
          <a class="button button-text notifications" routerLink="/dashboard/notifications"
            [routerLinkActive]="['active-item']" (click)="notificationCount()">
            <i class="material-icons"> notifications </i>
            <span class="number">{{count}}</span>
          </a>
          <a class="button button-text profile" mat-button [matMenuTriggerFor]="profile"
            [ngClass]="{'active-item': isProfileActive}">
            <i class="material-icons">
              person
            </i>
          </a>
        </div>
        <mat-menu #profile="matMenu" class="profile-items">
          <button mat-menu-item class="mat-btn" routerLink="/dashboard/profile" [routerLinkActive]="['active-item']">
            <i class="material-icons">person</i> Profile
          </button>

          <button mat-menu-item class="mat-btn" (click)="logout()">
            <span class="material-icons">
              exit_to_app
            </span> Logout
          </button>
        </mat-menu>
      </ng-container>
    </div>
  </div>
</header>